/*eslint-disable*/
import React, { useState, useContext } from "react";
import {
  Typography,
  ListItemIcon,
  Divider,
  MenuList,
  MenuItem,
  IconButton
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import MenuIcon from "@material-ui/icons/Menu";

import HomeIcon from "@material-ui/icons/Home";
import calendarIcon from "@material-ui/icons/CalendarToday";
import NotificationsIcon from '@mui/icons-material/Notifications';
import CarIcon from "@material-ui/icons/DirectionsCar";
import ListIcon from "@material-ui/icons/ListAlt";
import ExitIcon from "@material-ui/icons/ExitToApp";
import OfferIcon from "@material-ui/icons/LocalOffer";
import PeopleIcon from "@material-ui/icons/People";
import MoneyIcon from "@material-ui/icons/AttachMoney";
import NotifyIcon from "@material-ui/icons/NotificationsActive";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import Calendar from "@material-ui/icons/CalendarTodayOutlined";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import DashboardIcon from "@mui/icons-material/Dashboard";
import { language, features } from "config";
import assets from "assets";
import { FirebaseContext } from "common";

const useStyles = makeStyles((theme) => ({
  appMenuContainer: (props) => ({
    backgroundColor: "#399ddb",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "left center",
    minWidth: props.isCollapsed ? 80 : 160,
    [theme.breakpoints.up("sm")]: {
      minWidth: props.isCollapsed ? 80 : 180
    },
    [theme.breakpoints.up("md")]: {
      minWidth: props.isCollapsed ? 80 : 200
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: props.isCollapsed ? 80 : 240
    },
    [theme.breakpoints.up("xl")]: {
      minWidth: props.isCollapsed ? 80 : 260
    }
  }),

  menuToggleIcon: (props) => ({
    transition: "transform 0.3s ease-in-out",
    transform: props.isCollapsed ? "rotate(0deg)" : "rotate(180deg)"
  }),

  logoSection: (props) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(1),
    minHeight: props.isCollapsed ? 80 : 64,
    transition: "all 0.3s ease",
    [theme.breakpoints.up("md")]: {
      minHeight: props.isCollapsed ? 100 : 80
    }
  }),

  logo: (props) => ({
    width: props.isCollapsed ? "clamp(40px, 6vw, 60px)" : "80%",
    height: props.isCollapsed ? "clamp(40px, 6vw, 60px)" : "auto",
    objectFit: "contain",
    transition: "all 0.3s ease"
  }),

  collapsedLogo: {
    width: "clamp(40px, 6vw, 60px)",
    height: "clamp(40px, 6vw, 60px)",
    objectFit: "contain",
    alignItems: "left center",
    justifyContent: "left center"
  },

  menuItem: {
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#399ddb"
    },
    "&.Mui-selected": {
      backgroundColor: "#cee9f4",
      color: "#000000",
      "& .MuiListItemIcon-root": {
        color: "#000000"
      }
    }
  },

  menuItemText: {
    justifyContent: "center",
    fontSize: "clamp(0.75rem, 1vw, 1rem)",
    fontFamily: "Arial, sans-serif",
    fontWeight: 400,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },

  menuItemIcon: {
    color: "#ffffff",
    minWidth: "48px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  largerFont12pt: {
    fontSize: "clamp(0.9rem, 1.2vw, 1.2rem)",
    fontFamily: "Arial, sans-serif"
  },

  logoCollapseWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 2),
    minHeight: "64px"
  },

  collapseButton: (props) => ({
    color: "#ffffff",
    justifyContent: props.isCollapsed ? "center" : "flex-start"
  })
}));

function AppMenu({ isCollapsed, toggleDrawer }) {
  const { api } = useContext(FirebaseContext);
  const { signOut } = api;
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const classes = useStyles({ isCollapsed });

  const isActive = (path) => location.pathname === path;

  const LogOut = () => {
    dispatch(signOut());
    navigate("/");
  };

  let isSuperAdmin =
    auth.info &&
    auth.info.profile &&
    auth.info.profile.userType === "admin" &&
    auth.info.profile.isSuperAdmin;
  let isTenant =
    auth.info && auth.info.profile && auth.info.profile.userType === "tenant";
  let isAdmin =
    auth.info && auth.info.profile && auth.info.profile.userType === "admin";
  let isPracticeAdmin =
    auth.info && auth.info.profile && auth.info.profile.userType === "landlord";
  let isBroker =
    auth.info && auth.info.profile && auth.info.profile.userType === "broker";
  let isLandlord =
    auth.info && auth.info.profile && auth.info.profile.userType === "landlord";
  let isIndependentBroker =
    auth.info &&
    auth.info.profile &&
    !auth.info.profile.privatePractice &&
    auth.info.profile.userType === "broker";
  let isIndependentLandlord =
    auth.info &&
    auth.info.profile &&
    !auth.info.profile.privatePractice &&
    auth.info.profile.userType === "landlord";

  return (
    <div className={classes.appMenuContainer}>
      {/* Logo Section */}
      <div className={classes.logoSection}>
        {isCollapsed ? (
          // <img
          //   className={classes.collapsedLogo}
          //   src={assets.logo192x192}
          //   alt="Collapsed Logo"
          // />

          null

        ) : (
          <img className={classes.logo} src={assets.logo192x192} alt="Logo" />
        )}
      </div>

      <Divider style={{ backgroundColor: "#5a5a5a" }} />

      {/* Menu List */}
      <MenuList>
        <MenuItem onClick={toggleDrawer} className={classes.menuItem}>
          <ListItemIcon className={classes.menuItemIcon}>
            {isCollapsed ? <MenuIcon /> : <MenuOpenIcon />}
          </ListItemIcon>
          {!isCollapsed && (
            <Typography variant="inherit" className={classes.menuItemText}>
              Collapse Menu
            </Typography>
          )}
        </MenuItem>

        {features.WebsitePagesEnabled ? (
          <MenuItem
            component={Link}
            to="/"
            className={classes.menuItem}
            selected={isActive("/")}
          >
            <ListItemIcon className={classes.menuItemIcon}>
              <HomeIcon />
            </ListItemIcon>
            {!isCollapsed && (
              <Typography variant="inherit" className={classes.menuItemText}>
                {language.home}
              </Typography>
            )}
          </MenuItem>
        ) : null}

        {(isAdmin || isBroker) && (
          <>
            <MenuItem
              component={Link}
              to="/dashboard"
              className={classes.menuItem}
              selected={isActive("/dashboard")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <SpaceDashboardIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  Dashboard
                </Typography>
              )}
            </MenuItem>
            <MenuItem
              component={Link}
              to="/branches"
              className={classes.menuItem}
              selected={isActive("/branches")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <AccountTreeIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  Branch Management
                </Typography>
              )}
            </MenuItem>
              <MenuItem
              component={Link}
              to="/leadsNotifications"
              className={classes.menuItem}
              selected={isActive("/leadsNotifications")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <NotificationsIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  Leads
                </Typography>
              )}
            </MenuItem>
          </>
        )}

        {isSuperAdmin && (
          <MenuItem
            component={Link}
            to="/manageadmins"
            className={classes.menuItem}
            selected={isActive("/manageadmins")}
          >
            <ListItemIcon className={classes.menuItemIcon}>
              <DashboardIcon />
            </ListItemIcon>
            {!isCollapsed && (
              <Typography variant="inherit" className={classes.menuItemText}>
                Admins
              </Typography>
            )}
          </MenuItem>
        )}

        {isAdmin && (
          <>
            {/* <MenuItem
              component={Link}
              to="/profile"
              className={classes.menuItem}
              selected={isActive("/profile")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <PersonOutlineIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  {language.profile}
                </Typography>
              )}
            </MenuItem> */}

            <MenuItem
              component={Link}
              to="/manageLandlords"
              className={classes.menuItem}
              selected={isActive("/manageLandlords")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <DashboardIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  LandLords
                </Typography>
              )}
            </MenuItem>

            {/* <MenuItem
              component={Link}
              to="/editprofile"
              className={classes.menuItem}
              selected={isActive("/editprofile")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <PersonOutlineIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  Edit Profile
                </Typography>
              )}
            </MenuItem> */}

            {/* <MenuItem
              component={Link}
              to="/adduseradmin"
              className={classes.menuItem}
              selected={isActive("/adduseradmin")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <DashboardIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  User
                </Typography>
              )}
            </MenuItem> */}

            <MenuItem
              component={Link}
              to="/staff"
              className={classes.menuItem}
              selected={isActive("/staff")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <DashboardIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  Brokers
                </Typography>
              )}
            </MenuItem>

            <MenuItem
              component={Link}
              to="/addtenantadmin"
              className={classes.menuItem}
              selected={isActive("/addtenantadmin")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <DashboardIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  Tenant
                </Typography>
              )}
            </MenuItem>

            <MenuItem
              component={Link}
              to="/staffcalendar"
              className={classes.menuItem}
              selected={isActive("/staffcalendar")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <Calendar />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  {language.calendar}
                </Typography>
              )}
            </MenuItem>
          </>
        )}

        {isBroker && (
          <>
            <MenuItem
              component={Link}
              to="/brokerprofile"
              className={classes.menuItem}
              selected={isActive("/brokerprofile")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <PersonOutlineIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  {language.profile}
                </Typography>
              )}
            </MenuItem>

            <MenuItem
              component={Link}
              to="/editbrokerprofile"
              className={classes.menuItem}
              selected={isActive("/editbrokerprofile")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <PersonOutlineIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  Edit Profile
                </Typography>
              )}
            </MenuItem>

            <MenuItem
              component={Link}
              to="/brokerenquiries"
              className={classes.menuItem}
              selected={isActive("/brokerenquiries")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <PersonOutlineIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  Enquiries
                </Typography>
              )}
            </MenuItem>

            <MenuItem
              component={Link}
              to="/stock"
              className={classes.menuItem}
              selected={isActive("/stock")}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <DashboardIcon />
              </ListItemIcon>
              {!isCollapsed && (
                <Typography variant="inherit" className={classes.menuItemText}>
                  Listings
                </Typography>
              )}
            </MenuItem>
          </>
        )}

        {/* <MenuItem onClick={LogOut} className={classes.menuItem}>
          <ListItemIcon className={classes.menuItemIcon}>
            <ExitIcon />
          </ListItemIcon>
          {!isCollapsed && (
            <Typography variant="inherit" className={classes.menuItemText}>
              {language.logout}
            </Typography>
          )}
        </MenuItem> */}
      </MenuList>
    </div>
  );
}

export default AppMenu;
